import { localeInitial } from './locale';
import { screenInitial } from './screen';
import { userInitial } from './user';
import type { GlobalContextReducerState } from './types';
import { toastInitial } from './toast';
import { CoBrandDetailsInitial } from './CoBrandDetails';
import { activeFeatureConfigInitial } from './activeFeatureConfig';
import { Portal } from '@dfg/brahma-types';

export const defaultState: GlobalContextReducerState = {
  screen: screenInitial,
  locale: localeInitial,
  user: userInitial,
  toast: toastInitial,
  portal: Portal.IA,
  coBrandDetails: CoBrandDetailsInitial,
  activeFeatureConfig: activeFeatureConfigInitial
};
